import { Palette } from './palettes';

export interface InteriorPalette extends Palette {
    themeCompatibility: ('classic' | 'modern' | 'traditional')[];
    roomTypeCompatibility: string[];
    materialEmphasis: string[];
    moodTags: string[];
}

export const INTERIOR_PALETTES: InteriorPalette[] = [
    {
        id: 'ip1',
        name: 'Modern Neutrals',
        colors: ['#FFFFFF', '#F5F5F5', '#E5E5E5', '#525252', '#000000'],
        materials: ['White Oak', 'Concrete', 'Brushed Steel', 'Leather', 'Wool'],
        tags: ['modern', 'minimal', 'neutral', 'scandinavian'],
        themeCompatibility: ['modern'],
        roomTypeCompatibility: ['living_room', 'office', 'bedroom'],
        materialEmphasis: ['Clean lines', 'Matte finishes', 'Natural textures'],
        moodTags: ['Calm', 'Sophisticated', 'Airy', 'Uncluttered']
    },
    {
        id: 'ip2',
        name: 'Classic Elegance',
        colors: ['#2C1810', '#8B4513', '#D4AF37', '#F5F5DC', '#8B0000'],
        materials: ['Mahogany', 'Marble', 'Brass', 'Velvet', 'Silk'],
        tags: ['classic', 'luxury', 'traditional', 'rich'],
        themeCompatibility: ['classic', 'traditional'],
        roomTypeCompatibility: ['living_room', 'dining_room', 'study'],
        materialEmphasis: ['Ornate details', 'Luxury fabrics', 'Polished surfaces'],
        moodTags: ['Luxurious', 'Formal', 'Timeless', 'Elegant']
    },
    {
        id: 'ip3',
        name: 'Coastal Breeze',
        colors: ['#1E3A8A', '#38BDF8', '#FFFFFF', '#F0F9FF', '#0F766E'],
        materials: ['Teak', 'Rattan', 'Linen', 'Sea Glass', 'Driftwood'],
        tags: ['coastal', 'fresh', 'light', 'beach'],
        themeCompatibility: ['modern', 'traditional'],
        roomTypeCompatibility: ['living_room', 'bedroom', 'bathroom'],
        materialEmphasis: ['Natural fibers', 'Weathered finishes', 'Light woods'],
        moodTags: ['Relaxing', 'Fresh', 'Bright', 'Airy']
    },
    {
        id: 'ip4',
        name: 'Earth & Stone',
        colors: ['#3C2A21', '#654321', '#A0522D', '#D2691E', '#F5DEB3'],
        materials: ['Stone', 'Clay', 'Terracotta', 'Wool', 'Wood'],
        tags: ['earthy', 'natural', 'warm', 'organic'],
        themeCompatibility: ['traditional', 'modern'],
        roomTypeCompatibility: ['kitchen', 'living_room', 'study'],
        materialEmphasis: ['Natural materials', 'Textured surfaces', 'Handcrafted'],
        moodTags: ['Cozy', 'Grounding', 'Warm', 'Inviting']
    },
    {
        id: 'ip5',
        name: 'Urban Industrial',
        colors: ['#374151', '#6B7280', '#B45309', '#000000', '#F59E0B'],
        materials: ['Exposed Brick', 'Concrete', 'Black Steel', 'Reclaimed Wood', 'Copper'],
        tags: ['industrial', 'urban', 'loft', 'edgy'],
        themeCompatibility: ['modern'],
        roomTypeCompatibility: ['office', 'living_room', 'kitchen'],
        materialEmphasis: ['Raw materials', 'Metal accents', 'Unfinished textures'],
        moodTags: ['Bold', 'Edgy', 'Urban', 'Contemporary']
    },
    {
        id: 'ip6',
        name: 'Scandi Minimal',
        colors: ['#F3F4F6', '#E5E7EB', '#A8A29E', '#78716C', '#57534E'],
        materials: ['Pale Pine', 'White Plaster', 'Wool', 'Ceramic', 'Linen'],
        tags: ['scandinavian', 'minimal', 'cozy', 'light'],
        themeCompatibility: ['modern'],
        roomTypeCompatibility: ['bedroom', 'living_room', 'office'],
        materialEmphasis: ['Light woods', 'Textiles', 'Simple forms'],
        moodTags: ['Cozy', 'Clean', 'Simple', 'Peaceful']
    }
];

export const DEFAULT_INTERIOR_PALETTE_ID = 'ip1';